import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CoPresentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"co_present"}/>
}
